import { render, staticRenderFns } from "./BDXPreviewPopover.vue?vue&type=template&id=ba977cd0&scoped=true"
import script from "./BDXPreviewPopover.vue?vue&type=script&lang=js"
export * from "./BDXPreviewPopover.vue?vue&type=script&lang=js"
import style0 from "./BDXPreviewPopover.vue?vue&type=style&index=0&id=ba977cd0&prod&lang=css"
import style1 from "./BDXPreviewPopover.vue?vue&type=style&index=1&id=ba977cd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba977cd0",
  null
  
)

export default component.exports